export async function generateHashId(parts: string[], length = 7) {
  const id = (await hash(parts.join('.'))).slice(0, length)

  // Ids should never be fully numeric or they may mess with set()/hook-form
  // field ids. This replaces the first digit with a character instead.
  if (/^[0-9]+$/.test(id)) {
    const letter = 'abcdefghij'[Number(id[0])]
    return `${letter}${id.slice(1)}`
  }

  return id
}

export async function hash(value: string) {
  const enc = new TextEncoder()
  const hash = await crypto.subtle.digest('SHA-1', enc.encode(value))
  return Array.from(new Uint8Array(hash))
    .map((v) => v.toString(16).padStart(2, '0'))
    .join('')
}
